import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdError,
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdProps,
  GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult } from "./validators";

/**
 * Reads one action bank row from the agent's draft or live bank. The route's coded 404 is an answer,
 * not a failure: that bank does not hold the action. So the global error modal stays out of it; the
 * edit page's error-suppressing provider covers only the use-case read.
 */
export const getDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId,
  createGetFetcherFunctionWithShadowError<GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdError>()(
    (
      signal: AbortSignal,
      {
        appGroupId,
        dsaId,
        dimension,
        actionId,
        environment,
      }: GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdProps
    ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult> => {
      return fetch(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/dimensions/${dimension}/actions/${actionId}`,
        "GET",
        { environment },
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isGetDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult
);
